/**
 * Gateway for the per-section incremental query flow (Épico #21124, Frente B).
 *
 * Two endpoints, mirroring the backend's single dedicated router
 * (`apps/backend/domains/reports/routes_section_fetch_more.py`):
 *   - `fetchMoreSection` (task #21216): dispatch the incremental Snap query.
 *   - `persistSection` (task #21218): persist that section's encrypted
 *     content. `encrypted`/`iv` are ciphertext only — this gateway never
 *     sees or sends plaintext.
 */
import { EncryptedPayload } from "~/types/global";
import { REPORTS_CLIENT } from "../clients/reports.client";

export interface FetchMoreSectionPayload {
  network: string;
  identifierId?: string | null;
  identifierUsername?: string | null;
}

export interface FetchMoreSectionResponse {
  section_id: string;
  dispatched: Array<{ id: string }>;
}

export const fetchMoreSection = async (
  userReportsId: string,
  sectionId: string,
  payload: FetchMoreSectionPayload,
): Promise<FetchMoreSectionResponse> => {
  try {
    const response = await REPORTS_CLIENT.post(
      `/${userReportsId}/sections/${encodeURIComponent(sectionId)}/fetch-more`,
      {
        network: payload.network,
        identifier_id: payload.identifierId ?? null,
        identifier_username: payload.identifierUsername ?? null,
      },
    );
    return response.data;
  } catch (error) {
    console.error("fetchMoreSection Error dispatching section fetch-more:", error);
    throw error;
  }
};

export interface PersistSectionResponse {
  section_id: string;
  content_updated_at: string;
}

export const persistSection = async (
  userReportsId: string,
  sectionId: string,
  encrypted: EncryptedPayload,
): Promise<PersistSectionResponse> => {
  try {
    const response = await REPORTS_CLIENT.put(
      `/${userReportsId}/sections/${encodeURIComponent(sectionId)}`,
      { encrypted: encrypted.encrypted, iv: encrypted.iv },
    );
    return response.data;
  } catch (error) {
    console.error("persistSection Error persisting section:", error);
    throw error;
  }
};
